"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var DEP_MULTIPLIES = [1, 2, 3, 4, 5];
var useTableData = function (settings) {
    var t = (0, next_intl_1.useTranslations)('lottery');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var preparedPrices = (0, react_1.useMemo)(function () {
        var settingsPerCurrency = settings === null || settings === void 0 ? void 0 : settings.find(function (item) { return item.currency === currentCurrency; });
        return DEP_MULTIPLIES.map(function (multiplier) {
            return {
                deposit: "".concat(Number((settingsPerCurrency === null || settingsPerCurrency === void 0 ? void 0 : settingsPerCurrency.price) || 1) * multiplier, " ").concat((settingsPerCurrency === null || settingsPerCurrency === void 0 ? void 0 : settingsPerCurrency.currency) || currentCurrency),
                count: Number((settingsPerCurrency === null || settingsPerCurrency === void 0 ? void 0 : settingsPerCurrency.amount) || 1) * multiplier,
            };
        });
    }, [settings, currentCurrency]);
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'deposit',
                    label: t('deposit'),
                },
                {
                    field: 'ticketsEarned',
                    label: t('ticketsEarned'),
                },
            ],
            rows: [],
        };
        table.rows = preparedPrices.map(function (item) {
            if (!item.count)
                return null;
            return {
                deposit: react_1.default.createElement("span", null, item.deposit),
                ticketsEarned: react_1.default.createElement("span", null, item.count),
            };
        });
        return table;
    }, [t, preparedPrices]);
};
exports.useTableData = useTableData;
